import { VCS_AGENT_POOLS_COLUMN_ID } from "../constants";
import VCSAgentPoolsTableConnectionsCell from "./ConnectionsCell";
import VCSAgentPoolsTableDescriptionCell from "./DescriptionCell";
import VCSAgentPoolsTableDropdownCell from "./DropdownCell";
import VCSAgentPoolsTableNameCell from "./NameCell";

export const VCS_AGENT_POOLS_TABLE_CELLS = {
  [VCS_AGENT_POOLS_COLUMN_ID.NAME]: VCSAgentPoolsTableNameCell,
  [VCS_AGENT_POOLS_COLUMN_ID.DESCRIPTION]: VCSAgentPoolsTableDescriptionCell,
  [VCS_AGENT_POOLS_COLUMN_ID.AGENT_CONNECTIONS]: VCSAgentPoolsTableConnectionsCell,
  [VCS_AGENT_POOLS_COLUMN_ID.DROPDOWN]: VCSAgentPoolsTableDropdownCell,
};
